exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-blocked:hover,\n.btn-blocked.disabled {\n  background-color: #cc2424;\n  border-color: #b62020;\n}\n", ""]);

// exports
